import { Noto_Sans_Thai } from "@/fonts";
import { createTheme } from "@mui/material/styles";

const notosansthai = Noto_Sans_Thai;

const theme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#fafafa",
    },
  },
  typography: {
    fontFamily: notosansthai.style.fontFamily,
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.severity === "info" && {
            backgroundColor: "#60a5fa",
          }),
        }),
      },
    },
  },
});

export default theme;
